import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class GlobalConstants {
    /*public tenantId: number = 0;
    public tenantUID: string = '';
    public tenantName: string = '';*/

    /*public accessTypeKey: string = 'apikey';
    public accessTypeHook: string = 'webhook';*/
    private _userName: string = '';
    private _userRole: string = '';


    public successStatus: string = 'Success';
    public failureStatus: string = 'Failure';
    public commandStatus: string = 'COMMAND_SENT';

    public static apiURL: string = "https://nilan.com/";      
    public static siteTitle: string = "This is example of nilan.com";

    setUserName(userName: string) {
        this._userName = userName;
    }

    getUserName(): string {
        return this._userName;
    }

    setUserRole(role: string) {
        this._userRole = role;
    }

    getUserRole(): string {
        return this._userRole;
    }
}
